import { Reducer } from 'redux';
import {
  StopSellState,
  StopSellActionTypes,
  GET_STOP_SELL_LIST,
  GET_STOP_SELL,
  POST_STOP_SELL,
  PUT_STOP_SELL,
  DELETE_STOP_SELL,
  UPDATE_STOP_SELL_FILTERS
} from '../types/stopsell.types';

const initialState: StopSellState = {
  stopSells: [],
  selectStopSell: null,
  postSuccess: null,
  lastFetch: null,
  totalPages: 1,
  totalElements: 0,
  filters: null
};

export const stopSellReducer: Reducer<StopSellState> = (
  state: StopSellState = initialState, action
) => {
  const timeOfAction = new Date().getTime();
  switch ((action as StopSellActionTypes).type) {
    case GET_STOP_SELL_LIST:
      return {
        ...state,
        stopSells: action.payload.page.content,
        selectStopSell: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalPages: action.payload.page.totalPages,
        totalElements: action.payload.page.totalElements
      };
    case GET_STOP_SELL:
      return {
        ...state,
        postSuccess: null,
        selectStopSell: action.payload.selectedStopSell,
        lastFetch: timeOfAction
      };
    case POST_STOP_SELL:
      return {
        ...state,
        postSuccess: true,
        selectStopSell: action.payload.newStopSell,
        lastFetch: timeOfAction
      };
    case PUT_STOP_SELL:
      return {
        ...state,
        selectStopSell: action.payload.selectedStopSell,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_STOP_SELL:
      return {
        ...state,
        selectStopSell: null,
        lastFetch: timeOfAction
      };
    case UPDATE_STOP_SELL_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};
